// @flow

import React, { Component } from 'react';
import './ScalableLetterbox.css';

class ScalableLetterbox extends Component {
  node: Object;
  onResize: Function;
  state: { outerWidth: number, outerHeight: number, scale: number };

  constructor(props: Object) {
    super(props);

    this.state = { outerWidth: 0, outerHeight: 0, scale: 1 };
    this.onResize = this.onResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  renderChildren() {
    return React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {});
    });
  }

  render() {
    const { scale } = this.state;
    const { desiredWidth } = this.props;

    return (
      <div className="ScalableLetterbox" ref={node => (this.node = node)}>
        <div
          className="inner-box"
          style={{
            transform: `scale(${scale})`,
            width: `${desiredWidth}px`,
            transformOrigin: 'top left',
          }}>
          {this.renderChildren()}
        </div>
      </div>
    );
  }

  onResize() {
    const outerWidth = this.node ? this.node.clientWidth : 0;
    const outerHeight = this.node ? this.node.clientHeight : 0;

    const { desiredWidth, desiredHeight } = this.props;

    const horizontalScale = outerWidth / desiredWidth;
    const verticalScale = outerHeight / desiredHeight;
    const scale = 1.0 * Math.max(1, Math.min(horizontalScale, verticalScale));

    this.setState({ outerWidth, outerHeight, scale });
  }
}

export default ScalableLetterbox;



// WEBPACK FOOTER //
// ./src/components/ScalableLetterbox/ScalableLetterbox.js